// removed by extract-text-webpack-plugin
module.exports = {"tabular-select-input":"_2OPmDxY-i8cKVXJv_tB8EX","select":"_2bjP5_Cvv3Ml52UoCdvGHT","table-container":"_2cuR8i0p3ew0aVveFVqOOQ","spin":"_27I4BGV9nFlgFGqhyp9wNE"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/Input/TabularSelectInput/styles.scss
// module id = 950
// module chunks = 18